'use client'

import { useEmailVerify } from '@/hooks/useEmailVerify'
import Button from 'lib/components/Button/Button'
import { TextInputStandalone } from 'lib/components/Form'
import Header from 'lib/components/Header/Header'
import Link from 'lib/components/Link/Link'
import Notification from 'lib/components/Notification/Notification'
import { emailPattern } from 'lib/utilities/string'
import { useState } from 'react'

interface ResetPasswordProps {
  onCancel: () => void
  onSuccess: (email: string, channel?: 'sms' | 'email') => void
}

export default function ResetPassword({
  onCancel,
  onSuccess,
}: ResetPasswordProps) {
  const [email, setEmail] = useState('')
  const { loading, error, sendCode } = useEmailVerify()

  const isValidEmail = emailPattern.test(email)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const result = await sendCode(email)
    if (result.success) onSuccess(email, result.channel)
  }

  return (
    <form onSubmit={handleSubmit}>
      <Header as="h2" className="type-body-3 mb-4">
        Reset your password
      </Header>
      <p className="type-body-8 mb-4">
        Enter your email address to receive a verification code.
      </p>
      {error && (
        <Notification
          size="small"
          icon={{ icon: 'error' }}
          type="urgent"
          title={error}
          className="mb-4 !text-left"
        />
      )}
      <TextInputStandalone
        label="Email*"
        placeholder="Email address"
        name="emailAddress"
        disabled={loading}
        onChange={(val) => setEmail(String(val ?? ''))}
      />
      <Button
        type="submit"
        className="!mt-4 w-full !type-body-11-bold md:!type-body-5"
        disabled={loading || !isValidEmail}
      >
        {loading ? 'Sending...' : 'Send Code'}
      </Button>
      <div className="mt-4 text-center">
        <Link
          href="#"
          onClick={(e) => {
            e.preventDefault()
            onCancel()
          }}
          className="md:!text-xs"
        >
          Back to login
        </Link>
      </div>
    </form>
  )
}
